import {parseTownNews} from "../utils/town-news-payload";
import { apiGet } from '@/network/api-client';
import type { TownNewsSnapshot } from '../types/town-news.types';
export async function fetchTownNews(npcId: number, signal: AbortSignal): Promise<TownNewsSnapshot> {
  if(!Number.isSafeInteger(npcId)||npcId<=0)throw new Error("invalid NPC");
const raw=await apiGet<unknown>(`/npcs/${npcId}/news`,signal);const safe=parseTownNews(raw);if(!safe)throw new Error("invalid town news");return safe;
}
